function NotFoundPage() {
  return (
    <div className="bg-white h-[calc(100vh-380px)] w-full flex items-center justify-center text-center">
      <div className="mt-32 h-28 w-full bg-gray-500 max-w-lg rounded-lg px-6 flex items-center justify-center">
        <h2 className="text-white font-bold">PAGE NOT FOUND!</h2>
      </div>
    </div>
  );
}

export default NotFoundPage;
